/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _newArrowCheck from "@babel/runtime-corejs3/helpers/esm/newArrowCheck";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyNames from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-names";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";

/** @module core/modules/auto-clear-promises */
import { getValuesArray } from '../../object-utils/internals/get-values-array.js';
import { createStatePromise } from './create-state-promise.js';
/**
 * @description Tracks and clears resolved promises.
 * @param {(Array<Promise<*>>|Object<string,Promise<*>>)} promises - Promises.
 * @param {function(): void} [callback] - Callback.
 * @returns {void} Void.
 */

function autoClearPromises(promises, callback) {
  var _this = this,
      _context;

  var promisesArray = [];

  if (_Array$isArray(promises)) {
    promisesArray = promises;
  } else {
    promisesArray = getValuesArray(promises);
  }
  /**
   * @description Promise handler.
   * @returns {void} Void.
   */


  var handler = function handler() {
    var remainingPromises = null;

    if (_Array$isArray(promises)) {
      var i = 0;

      while (i < promises.length) {
        var promise = promises[i] = createStatePromise(promises[i]);

        if (!promise.isPending || !promise.isPending()) {
          _spliceInstanceProperty(promises).call(promises, i, 1);
        } else {
          i++;
        }
      }

      remainingPromises = promises.length;
    } else {
      for (var _i in promises) {
        if (!Object.hasOwnProperty.call(promises, _i)) {
          continue;
        }

        var _promise = promises[_i] = createStatePromise(promises[_i]);

        if (!_promise.isPending || !_promise.isPending()) {
          delete promises[_i];
        }
      }

      remainingPromises = _Object$getOwnPropertyNames(promises).length;
    }

    if (!remainingPromises) {
      callback && callback();
    }
  };

  _forEachInstanceProperty(promisesArray).call(promisesArray, _bindInstanceProperty(_context = function _context(promise) {
    _newArrowCheck(this, _this);

    promise.then(handler).catch(handler);
  }).call(_context, this));
}

export { autoClearPromises };